module.exports = __webpack_public_path__ + "static/media/Stannis Baratheon 3.50ecad96.jpg";